module.exports = __webpack_public_path__ + "static/media/arrow_canvas.b10aa97c.svg";